import { useCallback, useState } from 'react';

/** Gesteuert (value + onChange) oder ungesteuert (defaultValue), wie im Design System. */
export function useControlled<T>(value: T | undefined, defaultValue: T, onChange?: (v: T) => void): [T, (v: T) => void] {
  const [inner, setInner] = useState(defaultValue);
  const controlled = value !== undefined;
  const set = useCallback(
    (v: T) => {
      if (!controlled) setInner(v);
      onChange?.(v);
    },
    [controlled, onChange],
  );
  return [controlled ? (value as T) : inner, set];
}
